import { PRODUCTION_TYPES_ACTIONS } from 'store/v1/production_types/production_types.constants.js';
import { AUTH_ACTIONS } from 'store/v1/auth/auth.constants.js';

export const INITIAL_STATE = {
  data: {},
  paging: {},
  order: [],
  loading: false,
  fetched: false
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PRODUCTION_TYPES_ACTIONS.GET_PRODUCTION_TYPES:
    case PRODUCTION_TYPES_ACTIONS.CREATE_PRODUCTION_TYPE:
    case PRODUCTION_TYPES_ACTIONS.UPDATE_PRODUCTION_TYPE:
    case PRODUCTION_TYPES_ACTIONS.UPDATE_PRODUCTION_TYPE_ORDER:
    case PRODUCTION_TYPES_ACTIONS.DELETE_PRODUCTION_TYPE:
      return {
        ...state,
        loading: action.type,
        error: false
      };
    case AUTH_ACTIONS.LOAD_AUTH_SUCCESS: {
      const { production_types = [] } = action.result;
      return {
        ...state,
        data: production_types.reduce(
          (data, item) => ({ ...data, [item.id]: item }),
          {}
        ),
        order: production_types.map(item => item.id),
        loading: false,
        fetched: true
      };
    }
    case PRODUCTION_TYPES_ACTIONS.GET_PRODUCTION_TYPES_SUCCESS:
      return {
        ...state,
        data: action.result.results.reduce(
          (data, item) => ({ ...data, [item.id]: item }),
          {}
        ),
        order: action.result.results.map(item => item.id),
        paging: action.result.paging,
        loading: false,
        fetched: true
      };
    case PRODUCTION_TYPES_ACTIONS.UPDATE_PRODUCTION_TYPE_ORDER_SUCCESS:
      return {
        ...state,
        data: action.result.reduce(
          (data, item) => ({ ...data, [item.id]: item }),
          {}
        ),
        order: action.result.map(item => item.id),
        loading: false
      };
    case PRODUCTION_TYPES_ACTIONS.UPDATE_PRODUCTION_TYPE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.result.id]: action.result
        },
        loading: false
      };
    case PRODUCTION_TYPES_ACTIONS.CREATE_PRODUCTION_TYPE_SUCCESS:
      return {
        ...state,
        data: { ...state.data, [action.result.id]: action.result },
        order: [...state.order, action.result.id],
        loading: false
      };
    case PRODUCTION_TYPES_ACTIONS.DELETE_PRODUCTION_TYPE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.id]: {
            ...state.data[action.id],
            archived: true
          }
        },
        order: state.order.filter(id => id !== action.id),
        loading: false
      };
    case PRODUCTION_TYPES_ACTIONS.GET_PRODUCTION_TYPES_FAILURE:
    case PRODUCTION_TYPES_ACTIONS.UPDATE_PRODUCTION_TYPE_FAILURE:
    case PRODUCTION_TYPES_ACTIONS.CREATE_PRODUCTION_TYPE_FAILURE:
    case PRODUCTION_TYPES_ACTIONS.DELETE_PRODUCTION_TYPE_FAILURE:
    case PRODUCTION_TYPES_ACTIONS.UPDATE_PRODUCTION_TYPE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
